/**
 * Font Awesome kit icon name for a speciality, without the `fa-` prefix (e.g.
 * `speciality-oral-medicine`). The value is admin-managed reference data that
 * clients emit as a CSS class, so it is constrained to a bare slug: anything
 * with whitespace or punctuation could inject unrelated utility classes.
 */
export const SPECIALITY_ICON_NAME_PATTERN = /^[a-z0-9-]+$/;

/**
 * Variant vocabulary for the speciality icon. The web and native components render
 * these differently — Tailwind classes and CSS variables versus Font Awesome colour
 * props — but must offer the same options, so the vocabulary is owned here and each
 * implementation keys an exhaustive `Record` off it.
 */
export const SPECIALITY_ICON_TONES = [
  'brand',
  'onDark',
  'mono',
  'neutral',
] as const;
export type SpecialityIconTone = (typeof SPECIALITY_ICON_TONES)[number];

export const SPECIALITY_ICON_SURFACES = ['none', 'circle'] as const;
export type SpecialityIconSurface = (typeof SPECIALITY_ICON_SURFACES)[number];

export const SPECIALITY_ICON_DEFAULT_TONE: SpecialityIconTone = 'brand';
export const SPECIALITY_ICON_DEFAULT_SURFACE: SpecialityIconSurface = 'none';
